import React, { useEffect, useState } from 'react';
import { Modal, Form, Button, Alert } from '@themesberg/react-bootstrap';

const CiemModal = ({ show, onHide, onSubmit, initialData = {} }) => {
    //console.log(initialData.name)
    const [name, setName] = useState(initialData.name || '');
    const [description, setDescription] = useState(initialData.description || '');
    //setName(initialData.name)
    const [image, setImage] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        setName(initialData.name || '');
        setDescription(initialData.description || '');
    }, [initialData]);

    //console.log(name)
    // Validar y manejar la selección de la imagen
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 10 * 1024 * 1024) { // 10 MB
                setError('La imagen no puede pesar más de 10 MB.');
                return;
            }
            if (file.type !== 'image/png') {
                setError('Solo se permiten imágenes en formato PNG.');
                return;
            }
            setError('');
            setImage(file);
        }
    };

    // Manejar el envío del formulario
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!name || !description) {
            setError('Todos los campos son obligatorios.');
            return;
        }
        onSubmit({ name, description, image });
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{initialData.id ? 'Editar' : 'Crear nuevo'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Descripción (máximo 250 caracteres)</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            maxLength={250}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Imagen (PNG, máximo 10 MB) - Opcional</Form.Label>
                        <Form.Control
                            type="file"
                            accept="image/png"
                            onChange={handleImageChange}
                        />
                    </Form.Group>
                    <div className="d-flex justify-content-end">
                        <Button variant="secondary" onClick={onHide} className="me-2">
                            Cancelar
                        </Button>
                        <Button variant="primary" type="submit">
                            {initialData.id ? 'Guardar cambios' : 'Crear'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default CiemModal;